import { render, staticRenderFns } from "./tableobj.vue?vue&type=template&id=78643683"
import script from "./tableobj.vue?vue&type=script&lang=js"
export * from "./tableobj.vue?vue&type=script&lang=js"
import style0 from "./tableobj.vue?vue&type=style&index=0&id=78643683&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports